import { makeStyles, alpha } from "@material-ui/core/styles";
import styled from "styled-components";


const drawerWidth = 0;

export const NavLink = styled.a`
  text-decoration: none;
  font-size: 1.5rem;
  line-height: 32px;
  color: #e77f5a;
  transition: 0.4s ease;
  &:hover {
    color: #001219;
    opacity: 1;
    cursor: pointer;
  }
`;

export default makeStyles((theme) => ({
  appBar: {
    boxShadow: "none",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  title: {
    flexGrow: 1,
    alignItems: "center",
    display: "flex",
    textDecoration: "none",
  },
  image: {
    marginRight: "10px",
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  grow: {
    flexGrow: 1,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  navlinks: {
    marginLeft: theme.spacing(20),
    marginRight: theme.spacing(10),
    display: "flex",
  },
  link: {
    textDecoration: "none",
    color: "#e77f5a",
    fontSize: "20px",
    fontFamily: "Arial",
    marginLeft: theme.spacing(5),
    "&:hover": {
      color: "black",
      borderBottom: "1px solid white",
    },
  },
  a: {
    textDecoration: "none",
    textTransform: "none",
    color: "#e77f5a", 
    marginLeft:0,
    "&:hover": {
      color: "#0DADEA",
    },
  },
}));

